import React, { useCallback, useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

import { defaultOptions_Homologacao_Completo } from '../../../../../mocks/data';
import api from '../../../../../services/api';
import { ChartCard, Container } from '../styles';

const HomologacoesCompleto: React.FC = () => {
  const [graphConfig, setGraphConfig] = useState<any>(
    defaultOptions_Homologacao_Completo,
  );
  const [seriesHomologacao, setSeriesHomologacao] = useState<any[]>([]);

  const fetchDataHomologacao = useCallback(async () => {
    try {
      const response = await api.get('grafico/tempoHomologacaoCompleto');

      const dataHomologacao = response.data;
      const categorias = dataHomologacao.map((item: any) => item.descricao);

      const series = [
        {
          name: 'Quantidade',
          data: dataHomologacao.map((item: any) => item.quantidade),
          color: '#166649',
        },
      ];
      setSeriesHomologacao(series);
      const Config_Homologacoes = {
        ...graphConfig,

        stroke: {
          show: true,
          colors: ['#166649', '#ab934b'],
          width: 2,
          curve: 'smooth',
          lineCap: 'butt',
          dashArray: 0,
        },

        xaxis: { categories: categorias },
        plotOptions: {
          bar: {
            borderRadius: 5,
            columnWidth: '50%',
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            gradientToColors: undefined,
            shadeIntensity: 0.25,
            inverseColors: true,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
      };

      setGraphConfig(Config_Homologacoes);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    fetchDataHomologacao();
  }, [fetchDataHomologacao]);

  return (
    <>
      <ChartCard>
        <Container>
          <div style={{ height: '178px' }}>
            <h2>Quantidade de Homologações</h2>
          </div>
          <Chart
            options={graphConfig}
            series={seriesHomologacao}
            type="bar"
            height={350}
          />
        </Container>
      </ChartCard>
    </>
  );
};

export default HomologacoesCompleto;
